import { css } from 'styled-components';

export const pageContainer = css`
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
    padding-inline: 20px;
    padding-top: 100px;
`;
